import * as CryptoJS from 'crypto-js';
var cv = '';
function generateRandomString(length) {
  var text = '';
  let codeVerifier = localStorage.getItem('code_verifier');
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    for (var i = 0; i < length; i++) {
      text += possible.charAt(((Date.now() * i) * Date.now() + Date.now()) % possible.length);
    }
    cv = text;
    localStorage.setItem('code_verifier', cv);
    return text;
  }
}

function generateCodeChallenge(codeVerifier) {
  const codeChallange = base64URL(CryptoJS.SHA256(codeVerifier));
  return codeChallange + '&code_challenge_method=S256';
}

function base64URL(string: any) {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}

export const environment = {
  production: false,
  baseLoginUrl: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize?client_id=040e7dee-98b2-411a-a949-77c9a451030b&response_type=code&redirect_uri=https://uat.qa.msrs.toyota.com&response_mode=query&scope=openid&state=23343&code_challenge=',
  addressURL:'https://api.qa.msrs.toyota.com/subprod_address/api/',
  shippingURL:'https://api.qa.msrs.toyota.com/subprod_manageShipping/api/',
  createRequestURL:'https://api.qa.msrs.toyota.com/subprod_createRequest/api/',
  reportUrl:'https://api.qa.msrs.toyota.com/subprod_report/api/',
  viewRequestURL:'https://api.qa.msrs.toyota.com/subprod_viewRequest/api/',
  notificationURL: 'https://api.qa.msrs.toyota.com/subprod_notification/api/',
  dashboardURL: 'https://api.qa.msrs.toyota.com/subprod_dashboard/api/',
  partsSearchURL: 'https://api.qa.msrs.toyota.com/subprod_gtsparts/api/',
  signedUrl: 'https://jaz2njcz7l.execute-api.us-west-2.amazonaws.com/subprod/api',
  tokenURL: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  grantType: 'authorization_code',
  clientId: '040e7dee-98b2-411a-a949-77c9a451030b',
  // redirectURI: 'https://qa.msrs.toyota.com',
  redirectURI: 'https://uat.qa.msrs.toyota.com',
  // redirectURI: 'http://localhost:4200',
  codeVerifier: generateRandomString(128),
  codeChallenge: generateCodeChallenge(cv)
};
